import { DataSourceExecutionEvent, Image, ImageType, Snackbar } from "@mcleod/components";
import { AutogenLayoutInfoPacketPreview } from "./autogen/AutogenLayoutInfoPacketPreview";
import { UrlUtil } from "@mcleod/core";

export class InfoPacketPreview extends AutogenLayoutInfoPacketPreview {

    onLoad(): void {
        const props = UrlUtil.getPropsFromUrl(window.location.href);
        if (props?.key) {
            this.mainDataSource.search({"id": props.key, "preview": true });
        } else {
            Snackbar.showWarningSnackbar("No info packet key specified.", {persist: true});
        }
    }

    sourceInformationPacketAfterExecution(event: DataSourceExecutionEvent): void {
        this.panelPreview.removeAll();
        if (!this.activeRow.isNull("document_preview")) {
            const image = new Image({imageType: ImageType.PDF, fillHeight: true, fillRow: true, id: "infoPacketPreview"});
            image.imageBytes = this.activeRow.get("document_preview");
            this.panelPreview.add(image);
        }
    }
}